import React, { useEffect, useRef } from "react";
import * as THREE from "three";
import { useGLTF } from "@react-three/drei";

const ThreeDModelViewer = ({
  path,
  objectColors,
  selectedPart,
  setSelectedPart,
}) => {
  const { scene } = useGLTF(path);
  const ref = useRef();

  useEffect(() => {
    const model = scene.clone();

    model.traverse((child) => {
      if (child.isMesh) {
        const partName = child.name || child.uuid;

        if (partName) {
          child.userData.partName = partName; // make clickable
          if (!partName) {
            console.warn("Unnamed mesh found:", child);
            child.userData.partName = `Unnamed-${child.uuid}`;
          }
          

          const color = objectColors?.[partName]; // safely check
          if (color) {
            child.material = child.material.clone(); // avoid global material mutation
            child.material.color = new THREE.Color(color);
          }
        } else {
          console.warn("Unnamed mesh found:", child);
        }
      }
    });
    

    const box = new THREE.Box3().setFromObject(model);
    const center = box.getCenter(new THREE.Vector3());
    const size = box.getSize(new THREE.Vector3());
    const maxDim = Math.max(size.x, size.y, size.z);
    const scale = 1.5 / maxDim;

    model.position.sub(center);
    model.scale.setScalar(scale);

    ref.current.clear(); // remove old children
    ref.current.add(model);
  }, [scene, objectColors]);
 
 
  
  
  
  return (
    <group
      ref={ref}
      onClick={(e) => {
        e.stopPropagation(); // prevent bubbling to canvas
        // console.log("Clicked Object:", e.object);
        console.log("Object Name:", e.object.name);
        console.log("UserData:", e.object.userData);

        const part = e.object.userData.partName;
        if (part) {
          console.log("Selected Part:", part);
          if (typeof setSelectedPart === "function") {
            setSelectedPart(part);
          } else {
            console.warn("setSelectedPart is not a function");
          }
          
        } else {
          console.log("No partName in userData");
        }
      }}
    />
  );
};

export default ThreeDModelViewer;
